export default "__VITE_ASSET__BYVRp4EA__"